module.exports = __webpack_public_path__ + "assets/17f9138bcbd81212574a01758b3f8a04.svg";